//components
import ActivityFeed from  '@/components/elements/activityFeed/feeds/ActivityFeed';
import { IconButtonWithTooltip, IconLibrary } from 'thrive-components';
import useFeedFilters from '../activityFeedFilters/feedFilters/FeedFilters.hooks';
import UseDateFilter from '../activityFeedFilters/dateFilter/popOut/DateFilter.hooks';


const PopOutActivityFeedScreen = ({onClosePopOut, onShowFilterViewClick} : {onClosePopOut: any, onShowFilterViewClick:any}) => {  
    const {filterCount} = useFeedFilters();
    const { resetIsDisabled } = UseDateFilter();

    const activityScreenTitle = "Activity Feed";
    const fullPageButtonLabel = 'Open the full page view for Activity Feed';
    const filterButtonLabel = 'Open the filter panel';
    const className = "pop-out-feed-button below";
    const fullscreenClassName = `${className} full-screen-button`;
    const filterAlert = (filterCount > 0) || (!resetIsDisabled) ? "filter-alert" : ""  
    const filterScreenClassName = `${className} ${filterAlert} filter-screen-button`
    const fullPageButtonIcon = IconLibrary.MAXIMISE;
    const filterButtonIcon = IconLibrary.FILTERS;
    
    function onOpenFullScreenActivityFeed() {
        onClosePopOut();
        window.location.replace(`/ActivityFeed`);
    }

    return(
        <div className='pop-out-activity-feed-screen'>
            <div className='top-panel'>
                <h1>{activityScreenTitle}</h1>

                <div className='pop-out-feed-buttons'>
                    <IconButtonWithTooltip 
                        className={fullscreenClassName}
                        ariaLabel={fullPageButtonLabel}
                        iconName={fullPageButtonIcon}
                        onButtonClick={onOpenFullScreenActivityFeed} 
                        tooltipText={'Open full screen'}                    
                    />

                    <IconButtonWithTooltip 
                        className={filterScreenClassName}
                        ariaLabel={filterButtonLabel} 
                        iconName={filterButtonIcon} 
                        onButtonClick={onShowFilterViewClick}
                        tooltipText={'Filters'}                    
                    />
                </div>
             </div>

             <ActivityFeed isPopOut={true} />
        </div>
    )
}
export default PopOutActivityFeedScreen